<template>
  <div class="app-container text-center">
    <v-container>
      <div v-if="this.is_active === '1' && this.passed === 'pass'">
        <div v-if="this.currentTab === 'fundCompany'">
          <fund-company :company_id="company_id" :is_active="is_active" :passed="passed" />
        </div>

        <div v-else-if="this.currentTab === 'fundMemberInfo'">
          <fund-member-info :company_id="company_id" />
        </div>

        <div v-else>
          <div class="main-title">基金介绍</div>
          <v-container>
            <v-card>
              <v-card-title primary-title>
                <div>{{ fundInfoChart.description }}</div>
              </v-card-title>
            </v-card>
          </v-container>

          <br />

          <div class="main-title">基金报告</div>
          <div :class="className" :id="chart_id" :style="{height:height, width: device === 'desktop' ? '50%' : '100%', margin:margin}" />
          <v-container grid-list-md text-xs-center>
            <v-layout row wrap>
              <v-flex :style="device==='desktop' ? 'xs4 md4' : 'xs12 md12'">
                <div>净值估算</div>
                <h2 :style="{ color: valueColor }">{{ fundInfoChart.value }}
                  <i :class="valueColor==='red' ? 'el-icon-caret-top' : 'el-icon-caret-bottom'" />
                </h2>
                <div>近期：{{ fundInfoChart.recent_value }}</div>
              </v-flex>
              <v-flex :style="device==='desktop' ? 'xs4 md4' : 'xs12 md12'">
                <div>单位净值</div>
                <h2 :style="{ color: unitColor }">{{ fundInfoChart.unit_value }}
                  <i :class="unitColor==='red' ? 'el-icon-caret-top' : 'el-icon-caret-bottom'" />
                </h2>
                <div>近期：{{ fundInfoChart.recent_unit_value }}</div>
              </v-flex>
              <v-flex :style="device==='desktop' ? 'xs4 md4' : 'xs12 md12'">
                <div>累计净值</div>
                <h2 :style="{ color: cumulativeColor }">{{ fundInfoChart.cumulative_value }}
                  <i :class="cumulativeColor==='red' ? 'el-icon-caret-top' : 'el-icon-caret-bottom'" />
                </h2>
                <div>近期：{{ fundInfoChart.recent_cumulative_value }}</div>
              </v-flex>
            </v-layout>
            <hr>
            <v-layout row wrap>
              <v-flex :style="device==='desktop' ? 'xs4 md4' : 'xs12 md12'">
                <div>基金类型：{{ fundInfoChart.type }}</div>
                <div>成立日：{{ fundInfoChart.estabilsh_date }}</div>
              </v-flex>
              <v-flex :style="device==='desktop' ? 'xs4 md4' : 'xs12 md12'">
                <div>基金规模：{{ fundInfoChart.scale }}</div>

                <div @click="changeTab('fundCompany')" style="cursor: pointer;">
                  管理人：{{ companyName }}
                </div>
              </v-flex>
              <v-flex :style="device==='desktop' ? 'xs4 md4' : 'xs12 md12'">
                <div @click="changeTab('fundMemberInfo')" style="cursor: pointer;">
                  基金经理：{{ name }}
                </div>
                <!-- <div>
              <v-rating v-model="fundInfoChart.rating" background-color="orange lighten-3" color="orange" small readonly></v-rating>
            </div> -->
              </v-flex>
            </v-layout>
          </v-container>
          <div class="main-title">基金公告</div>
          <v-container>
            <v-list subheader two-line>
              <v-list-tile @click="announceInfo(item, true)" :key="item.id" avatar v-for="item in announceByUser">
                <template>
                  <v-list-tile-avatar>
                    <v-icon class="blue white--text">assignment</v-icon>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-btn icon ripple>
                      <v-icon color="grey lighten-1">info</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </template>
              </v-list-tile>
            </v-list>

            <v-dialog v-model="announce_dialog" width="600px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ current_announce.title }}</span>
                </v-card-title>
                <v-card-text>
                  <img :src="`/cannan_api/images/${current_announce.img}`" alt style="display:block;max-width:100%; margin:0 auto;">
                  <div class="body-1" v-html="current_announce.content">{{ current_announce.content }}</div>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-container>
        </div>
      </div>
    </v-container>
    <!-- <div v-if="this.is_active === '0'">
      风险评测未通过
    </div>
    <div v-else>
      请先完成风险评测
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import echarts from 'echarts'
import FundCompany from '@/components/FundCompany.vue'
import FundMemberInfo from '@/components/FundMemberInfo.vue'

export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    chart_id: {
      type: String,
      default: 'pos_chart'
    },
    width: {
      type: String,
      default: '800px'
    },
    height: {
      type: String,
      default: '600px'
    },
    margin: {
      type: String,
      default: '0 auto'
    },
    route_id: {
      type: Number,
      default: ''
    },
    is_active: {
      type: String,
      default: false
    },
    passed: {
      type: String,
      default: 'no_pass'
    }
  },
  components: {
    FundCompany,
    FundMemberInfo
  },
  data() {
    return {
      chart: null,
      items: {},
      device: 'desktop',
      manager_id: '',
      name: '',
      company_id: '',
      companyName: '',
      valueColor: '',
      unitColor: '',
      cumulativeColor: '',
      currentTab: '',
      current_announce: '',
      announce_dialog: ''
    }
  },
  computed: mapGetters({
    fundInfoChart: 'fundInfoChart',
    fundMemberInfo: 'fundMemberInfo',
    userInfo: 'userInfo',
    announceByUser: 'announceByUser'
  }),
  watch: {
    fundInfoChart: {
      handler(newValue, oldValue) {
        if (this.chart) {
          if (newValue) {
            // this.chart.clear()
            this.initChart(newValue)
          } else {
            this.initChart(oldValue)
          }
        } else {
          this.init()
        }
      },
      deep: true
    },
    route_id: {
      handler(newValue, oldValue) {
        if (this.chart) {
          if (newValue) {
            this.currentTab = ''
            this.fetchData()
            // this.chart.clear()
            this.initChart(newValue)
          } else {
            this.initChart(oldValue)
          }
        } else {
          this.fetchData()
          this.currentTab = ''
        }
      },
      deep: true
    }
  },
  created() {
    this.fetchData()

    if (
      navigator.userAgent.indexOf('iPhone') > -1 ||
      navigator.userAgent.indexOf('Android') > -1
    ) {
      this.device = 'mobile'
    } else {
      this.device = 'desktop'
    }
  },
  mounted() {
    this.initChart()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    fetchData() {
      this.listLoading = true
      this.$store.dispatch('GetFundInfoChart', this.route_id).then(response => {
        this.valueColor =
          this.fundInfoChart.value - this.fundInfoChart.recent_value < 0
            ? 'green'
            : 'red'
        this.unitColor =
          this.fundInfoChart.unit_value - this.fundInfoChart.recent_unit_value <
          0
            ? 'green'
            : 'red'
        this.cumulativeColor =
          this.fundInfoChart.cumulative_value -
            this.fundInfoChart.recent_cumulative_value <
          0
            ? 'green'
            : 'red'

        this.$store
          .dispatch('GetFundMemberInfo', this.fundInfoChart.manager_id)
          .then(res => {
            this.manager_id = this.fundMemberInfo[0].id
            this.name = this.fundMemberInfo[0].name
            this.company_id = this.fundMemberInfo[0].company_id
            this.companyName = this.fundMemberInfo[0].company_title
          })
        this.listLoading = false
      })
      this.$store.dispatch('GetAnnounceByUser', this.userInfo.data)
    },
    initChart(items) {
      this.chart = echarts.init(document.getElementById(this.chart_id))

      const valueData = [
        this.fundInfoChart.value,
        this.fundInfoChart.unit_value,
        this.fundInfoChart.cumulative_value
      ]
      const currentValueData = [
        this.fundInfoChart.recent_value,
        this.fundInfoChart.recent_unit_value,
        this.fundInfoChart.recent_cumulative_value
      ]

      const option = {
        title: {
          text: '净值图表'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        toolbox: {
          show: true,
          feature: {
            dataView: { show: false, readOnly: false },
            magicType: { show: false, type: ['line', 'bar'] },
            restore: { show: false },
            saveAsImage: { show: false }
          }
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            data: ['净值估算', '单位净值', '累计净值']
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '净值',
            type: 'bar',
            data: valueData,
            markPoint: {
              data: [
                { type: 'max', name: '最大值' },
                { type: 'min', name: '最小值' }
              ]
            },
            markLine: {
              data: [{ type: 'average', name: '平均值' }]
            }
          },
          {
            name: '最近净值',
            type: 'bar',
            data: currentValueData,
            markPoint: {
              data: [{ name: '最大值' }, { name: '最小值' }]
            },
            markLine: {
              data: [{ type: 'average', name: '平均值' }]
            }
          }
        ]
      }
      option.series[0].data = valueData
      option.series[1].data = currentValueData
      this.chart.setOption(option)
    },
    changeTab(link) {
      this.currentTab = link
    },
    announceInfo(announce, flag) {
      this.current_announce = announce
      this.announce_dialog = flag
    }
  }
}
</script>

<style lang="scss" scoped>
.el-rate::before {
  content: '基金評級：';
}
</style>

